"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApplicationInfoHttpClient = void 0;
const index_1 = require("../Types/index");
const BaseClient_1 = require("./BaseClient");
class ApplicationInfoHttpClient extends BaseClient_1.BaseClient {
    get connected() {
        var _a;
        const socketIoClient = this.socketIoManager.getSocketForIdentity(this.identity);
        return (_a = socketIoClient === null || socketIoClient === void 0 ? void 0 : socketIoClient.connected) !== null && _a !== void 0 ? _a : false;
    }
    async getApplicationInfo() {
        const requestAuthHeaders = this.createRequestAuthHeaders(this.identity);
        const url = this.buildUrl(index_1.restSettings.paths.getApplicationInfo);
        const httpResponse = await this.httpClient.get(url, requestAuthHeaders);
        return httpResponse.result;
    }
    async getAuthorityAddress() {
        const requestAuthHeaders = this.createRequestAuthHeaders(this.identity);
        const url = this.buildUrl(index_1.restSettings.paths.getAuthorityAddress);
        const httpResponse = await this.httpClient.get(url, requestAuthHeaders);
        return httpResponse.result;
    }
    onConnected(callback, subscribeOnce) {
        return this.createSocketIoSubscription('connect', callback, subscribeOnce);
    }
    onDisconnected(callback, subscribeOnce) {
        return this.createSocketIoSubscription('disconnect', callback, subscribeOnce);
    }
    onReconnected(callback, subscribeOnce) {
        return this.createSocketIoSubscription('reconnect', callback, subscribeOnce);
    }
}
exports.ApplicationInfoHttpClient = ApplicationInfoHttpClient;
//# sourceMappingURL=ApplicationInfoHttpClient.js.map